import { Bar, BarConfig } from '@ant-design/plots';
import { useQuery } from '@apollo/client';
import { GET_POPULAR_TOPICS, PopularTopic } from '@frontend/data-access';
import { Card, Select } from 'antd';
import useTranslation from 'next-translate/useTranslation';
import { useState } from 'react';

const PopularTopicsStats = ({ className }: { className?: string }) => {
  const { t } = useTranslation('admin');
  const [topicFilter, setTopicFilter] = useState<string[]>([]);
  const [topics, setTopics] = useState<PopularTopic[]>([]);
  const { data, loading } = useQuery<{ popularTopics: PopularTopic[] }>(
    GET_POPULAR_TOPICS,
    {
      variables: {
        limit: 50,
      },
      onCompleted: (data) => {
        setTopics(data.popularTopics);
      },
    }
  );

  const config: BarConfig = {
    data: topics,
    loading,
    xField: 'count',
    yField: 'topic',
    color: '#3BA1FF',
    appendPadding: [0, 20, 0, 0],
    yAxis: {
      label: {
        formatter: (value) =>
          value.length > 30 ? value.slice(0, 30) + '...' : value,
        style: {
          fontFamily: 'Lufga',
          fill: 'rgba(0, 0, 0, 0.65)',
          textAlign: 'right',
        },
        labelFormatter: (value) =>
          value.length > 30 ? value.slice(0, 30) + '...' : value,
      },
    },
    label: {
      text: 'count',
      position: 'right',
      textAlign: 'start',
      dx: 8,
      style: {
        fill: 'rgba(0, 0, 0, 0.65)',
        fontFamily: 'Lufga',
      },
    },
  };

  return (
    <Card
      style={{
        borderRadius: 20,
      }}
      className={`${className}`}
    >
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <div className="text-sm text-gray-900 font-medium">
            {t('users_by_topics')}
          </div>
          <Select
            className="!w-[300px]"
            onChange={(value: string[]) => setTopicFilter(value)}
            options={data?.popularTopics?.map((item) => ({
              label: item.topic,
              value: item.topic,
            }))}
            value={topicFilter}
            placeholder={t('filter_by_topic')}
            allowClear
            mode="multiple"
            style={{ width: '100%', borderRadius: 20 }}
            maxTagCount="responsive"
            optionFilterProp="label"
          />
        </div>
        <Bar
          {...config}
          data={topics.filter(
            (item) =>
              topicFilter?.length === 0 || topicFilter.includes(item?.topic)
          )}
        />
      </div>
    </Card>
  );
};

export default PopularTopicsStats;
